<template>
  <div>
    <b-row>
      <b-col
        md="6"
        xl="6"
        class="mb-1"
      >
        <b-card-code>
          <b-row>
            <b-col
              md="4"
              xl="4"
              class="mb-1"
            >
              <b-form-group
                label="Flugnr."
              >
                <b-form-input />
              </b-form-group>
            </b-col>

            <b-col
              md="4"
              xl="4"
              class="mb-1"
            >
              <b-form-group
                label="Start"
              >
                <b-form-input />
              </b-form-group>
            </b-col>
            <b-col
              md="4"
              xl="4"
              class="mb-1"
            >
              <b-form-group
                label="Ziel"
              >
                <b-form-input />
              </b-form-group>
            </b-col>
          </b-row>
          <div v-for="(item, index) in ScheduledTimes">
            <b-row>
              <b-col
                  md="4"
                  xl="4"
                  class="mb-1"
              >DA{{ index }}.
                <b-form-group
                    label="(Start / Landezeit)"
                >
                  <b-form-input v-model="ScheduledTimes[index].Scheduled" />
                </b-form-group>
              </b-col>
              <b-col
                  md="4"
                  xl="4"
                  class="mb-1"
              >
                <b-form-group
                    label="Mo. (Pickup Zeit)"
                >
                  <b-form-input v-model="ScheduledTimes[index].Pickup" />
                </b-form-group>
              </b-col>
            </b-row>
          </div>

        </b-card-code>
      </b-col>

      <b-col
        md="6"
        xl="6"
        class="mb-1"
      >
        Y
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
  BFormInput, BRow, BCol, BFormGroup, BButton,
} from 'bootstrap-vue'

export default {
  name: 'FlightNew',
  components: {
    BCardCode,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BButton,
  },
  data() {
    return {
      FlightId: 0,
      IataCode: '',
      Departure: '',
      Arrivals: '',
      ScheduledTimes:
        {
          0: {
            Scheduled: '',
            Pickup: '',
          },
        },
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Flug ' + this.$route.params.id
    })
    if (this.$route.params.id > 0) {
      this.Load(this.$route.params.id)
    }

    console.log(this.ScheduledTimes)
  },
  methods: {
    Load(planId) {
      this.$http.get(`/flightPlan/get/${planId}`)
        .then(resp => {
          console.log(resp)
          var f = resp.data.data;
          for (let i = 0, len = 7; i < len; i++) {
            this.ScheduledTimes[i] = {
              Scheduled: f.ScheduledTimes[i],
              Pickup: f.PickupTime[i],
            }
          }
          console.log(this)
          // resp.data.ScheduledTimes.forEach(f => {
          //   this.ScheduledTimes.push()
          // })
        })
        .catch(err => {
          console.error(err)
        })
    },
  },
}
</script>

<style scoped>

</style>
